import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { HandingQuoteModel, SimpleAirportModel } from '@shared/models/handling-quote.model';

export class EmailPatterns {
  static email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]{1,}\.[a-zA-Z]{2,}$/;
}

export const getDataLayerInputParams = (inputParams: {[key:string]: any}) => {
  return inputParams.reduce((acc, input)=> {
    acc[input.key] = input.value
    return acc
  }, {})
}

export const getDataLayerServices = (formVal, dataVal: HandingQuoteModel) => {
  const evoServices = mapServiceIdToName(dataVal.evoServices)
  const percentageServices = mapServiceIdToName(dataVal.percentageServices)
  const optionalServices = mapServiceIdToName(dataVal.optionalServices)
  const {optionalEvoServices, optionalHandlerServices, optionalPriceListServices} = formVal;

  return [
    ...optionalEvoServices.map(service => evoServices.get(service.optionalEvoService)),
    ...optionalHandlerServices.map(service => optionalServices.get(service.optionalHandlerService)),
    ...optionalPriceListServices.map(service => percentageServices.get(service.optionalPriceListServices))
  ]
}

const mapServiceIdToName = (service)=>{
  const mapService = new Map()
  service.forEach(item=> {
    mapService.set(item.id, item.name)
  })

  return mapService
}

const setErrorVal = (form, key, errors) => {
  const control = form.get(key);
  if (errors[key].errors && errors[key].errors.length) {
    control.setErrors({
      ...control.errors,
      serverError: errors[key].errors[0]
    });
  }
};

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  constructor() {
  }

  emailValidator(name: string = 'Email', message: string = 'Invalid'): ValidatorFn {
    const fullMessage = `${message} ${name}`;
    return (control: AbstractControl): ValidationErrors => {

      if (control.value && !EmailPatterns.email.test(control.value)) {
        return {
          email: fullMessage
        };
      }
      return null;
    };
  }

  searchAirport(term: string, {icao, iata, name}: SimpleAirportModel) {
    term = term.toLocaleLowerCase();
    const itemLine = `${icao} / ${iata} - ${name}`;
    return itemLine.toLocaleLowerCase().indexOf(term) > -1;
  }


  setFormTouched(form) {
    for (const i in form.controls) {
      form.controls[i].markAsDirty();
      form.controls[i].markAsTouched();
      // Avoid emitting valueChanges when validating/touching programmatically
      form.controls[i].updateValueAndValidity({ emitEvent: false });
    }
  }

  findErrors(form, key, errors) {
    const errorObject = key;
    const errorObjectKeys = Object.keys(errors);

    errorObjectKeys.forEach((objVal) => {
      const childrenErrors = errors[objVal].children;

      if (childrenErrors && Array.isArray(childrenErrors)) {
        return this.findErrors(form, key, errors[objVal].children);
      }

      if (childrenErrors && (typeof childrenErrors === 'object')) {
        const childrenErrorsKeys = Object.keys(childrenErrors);

        childrenErrorsKeys.forEach((error) => {
          if (childrenErrors[error].children) {

            childrenErrors[error].children.forEach((val) => {
              if (val.errors && form.get(errorObject)) {
                const controls = form.get(errorObject).controls;
                setErrorVal(controls[objVal], val, childrenErrors);
              }
            });
          }

          if (childrenErrors[error].errors && form.get(errorObject)) {
            const controls = form.get(errorObject).controls;
            setErrorVal(controls[objVal], error, childrenErrors);
          }
        });
      } else if (Array.isArray(errors[objVal].errors)) {
        const groupChildForm: UntypedFormGroup = form.get(errorObject);
        const groupChildErrors: any = {children: errors};
        this.apiToFormErrors(groupChildForm, groupChildErrors);
      }
    });
  }

  apiToFormErrors(form: UntypedFormGroup, apiErrors: any) {
    for (const key in apiErrors) {
      if (apiErrors.hasOwnProperty(key) && form.controls[key]) {
        const control = form.get(key);
        if (Array.isArray(apiErrors[key]) && apiErrors[key].length > 0) {
          control.setErrors({
            ...control.errors,
            serverError: apiErrors[key][0]
          });
        }
      }
    }
  }

  downloadPdf(res, name) {
    let blob = new Blob([res], {type: 'application/pdf'});

    const link = document.createElement('a');

    link.href = window.URL.createObjectURL(blob);
    link.setAttribute('download', name);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
